import React from "react";
import { TABS } from "../lib/constants";

export function TabBar({ active, onChange }) {
  return (
    <div className="sticky top-[64px] z-30 bg-[var(--bg)]/95 backdrop-blur-md border-b border-[var(--bd)]" data-testid="tab-bar">
      <div className="max-w-[1500px] mx-auto px-2 sm:px-4">
        <div className="flex gap-1 overflow-x-auto hide-scrollbar">
          {TABS.map(({ id, label, icon: Icon }) => {
            const isActive = active === id;
            return (
              <button
                key={id}
                onClick={() => onChange(id)}
                data-testid={`tab-${id}`}
                className={`relative flex items-center gap-2 px-4 py-3 whitespace-nowrap text-sm font-medium transition-colors duration-200 border-b-2 ${
                  isActive
                    ? "text-[var(--t1)] border-[var(--accent)]"
                    : "text-[var(--t2)] border-transparent hover:text-[var(--t1)]"
                }`}
              >
                <Icon size={16} strokeWidth={2.2} className={isActive ? "text-[var(--accent)]" : ""} />
                {label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
